"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordBaseSchema = void 0;
exports.recordBaseSchema = {
    type: 'object',
    additionalProperties: true,
    required: [
        'recordID',
        'cmhcLoanAccountNumber',
        'recordCreatedTimestamp',
        'recordCreatedUserID',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'reportingPeriod',
    ],
    properties: {
        recordID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        reportingPeriod: {
            type: 'string',
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
    },
};
